import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const LocationAPI = {
  getLocations: async (token, queryParams = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/location/list`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
  getLocation: async (token, id) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/location/?id=${id}`,
      headers: { Authorization: token },
    });
  },
  createLocation: async (token, data) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/location/`,
      headers: { Authorization: token },
      data: { ...data },
    });
  },
  updateLocation: async (token, data) => {
    return await axios({
      method: "PUT",
      url: `${BACKEND_ORIGIN}/api/location/`,
      headers: { Authorization: token },
      data: { ...data },
    });
  },
};

export default LocationAPI;
